module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_05-08d5e3ab07e09c414b2f0170edd863bc.svg";